<template>
  <div class="popup-full">
    <BasePreloader v-if="loading.submit" />

    <div class="popup-full__content">
      <h1 class="popup-full__title" style="text-align: left;">
        {{ $tVacancy('select_candidate') }}
      </h1>

      <BaseSelect
        v-model="selectedCandidate"
        :label="$tVacancy('candidate')"
        text-key="fullname"
        :options="candidates"
        :loading="loading.candidates"
        class="mt-6"
        @search="onSearchInput"
        @input="removeStoredCandidateId"
      />

      <div class="mt-5">
        <button
          :disabled="!selectedCandidate"
          class="base-btn base-btn--green full-width"
          @click="onCandidateSubmit"
        >
          {{ $tVacancy('select_this_candidate') }}
        </button>
      </div>

      <div class="mt-7">
        <div class="popup-full__text">
          {{ $tVacancy('didnt_find_right_candidate') }}
        </div>

        <button
          class="base-btn base-btn--blue ml-auto"
          @click="inviteCandidate"
        >
          {{ $tVacancy('invite_candidate') }}
        </button>
      </div>

      <BaseAlert
        v-if="errors"
        :value="errors"
        class="mt-5 _warning"
      />
    </div>
  </div>
</template>

<script>
import { http } from '../axios';

let inputTimout = null;

export default {
  name: 'SelectCandidateModal',
  props: {
    modalName: String,
    vacancyId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      loading: {
        candidates: false,
        submit: false,
      },
      showInvitePopup: false,
      selectedCandidate: null,
      candidates: [],

      errors: null,
    };
  },
  async created() {
    await this.loadCandidates();
    this.setSelectedCandidateFromStorage();
  },
  methods: {
    loadCandidates(queryValue) {
      this.loading.candidates = true;

      return http.get('/api/new-vacancy/partner/get-customers', { params: { q: queryValue } })
        .then(({ data }) => this.candidates = data.data)
        .finally(() => this.loading.candidates = false)
    },
    setSelectedCandidateFromStorage() {
      const candidateId = sessionStorage.getItem('selected_response_candidate_id');

      this.selectedCandidate = this.candidates.find(c => c.customer_id === +candidateId) || null;
    },
    onSearchInput(value) {
      clearTimeout(inputTimout);
      inputTimout = setTimeout(() => {
        this.loadCandidates(value);
      }, 700);
    },
    removeStoredCandidateId() {
      sessionStorage.removeItem('selected_response_candidate_id');
    },
    onCandidateSubmit() {
      this.loading.submit = true;

      http.post(`/api/vacancy/${this.vacancyId}/send-resume`, { send_customer_id: this.selectedCandidate.customer_id })
        .then(({ data }) => {
          this.removeStoredCandidateId();
          this.$vModal.close(this.modalName);
          this.$router.push({ name: 'response-additional-questions', params: { sentResumeId: data.sent_resume_id } });
        })
        .finally(() => this.loading.submit = false)
    },
    inviteCandidate() {
      const modalName = 'enter-phone-number';
      this.$vModal.open(modalName, {
        title: this.$tVacancy('thanks_for_response'),
        subtitle: this.$tVacancy('leave_your_contact_data'),
        submitBtnText: this.$tVacancy('select_candidate_add'),
        onSubmit: async ({ name, phone }) => {
          this.$vModal.close(modalName);
          this.errors = null;

          this.loading.submit = true;
          try {
            const { data } = await http.post('/api/cabinet/agent/register-candidate-byphone', {
              vacancy_id: this.vacancyId,
              name,
              phone,
            });

            if (!data?.send_resume) return;

            this.$router.push({ name: 'response-additional-questions', params: { sentResumeId: data.send_resume.sent_resume_id } });
            this.$vModal.close(this.modalName);
          } catch (e) {
            if (e.response) {
              const { errors, message } = e.response.data;
              if (errors) this.errors = errors;
              else this.errors = [message];
            }
          } finally {
            this.loading.submit = false;
          }
        },
      });
    },
  },
};
</script>
